import Event from "./Event.mjs";
import appLib from "../../../libs/appLib.mjs";
import {Button, UncontrolledTooltip} from "reactstrap";
import TextLabel from "../../../Controls/TextLabel.mjs";
import React from "react";

const G = window.glob;

const EventStartStep = class extends Event {
	constructor(props) {
		super(props);
		this.state = { interval: 5000, isGM: G.getStatus('Player')?.admin?.gameMaster };
		this.check = this.check.bind(this);
		this.clock = this.clock.bind(this);
		this.buildClock = this.buildClock.bind(this);
		this.doneButton = this.doneButton.bind(this);
	}
	componentDidMount() {
		this.check(this.props.event, this.props.options.game, this.props.options.copione);
	}
	buildClock() {
		let exp;
		const curr = appLib.timer2current( this.state.timer );
		const rep = curr / this.state.maxtime;
		if ( rep > 1 ) exp = "expired";
		else if ( rep > .75 ) exp = "expiring";
		else exp = "valid";
		return(
			<span className={"timer"}>
				<span className={"time "+exp}>
					{ appLib.timer2string( this.state.timer ) }
				</span>
				<span className={"total"}>
					{  appLib.msec2string(this.state.maxtime) }
				</span>
			</span>
		);
	}
	check(e,g,c) {
		const action = c.action[ e?.id ];
		if ( ! action || typeof g.done[ e.id ] !== 'undefined' ) {
			if ( this.state.timeout ) try { window.clearTimeout( this.state.timeout ) } catch(e){}
			this.setState({ clock: false, timeout: false, timer: false });
			return "";
		}
		const timer = appLib.timer( e, e.time );
		if ( timer ) {
			this.setState({
				timer: timer,
				maxtime: action.maxtime,
				timerStarted: timer.time + timer.timer
			}, ()=>{
				this.setState({
					clock: this.buildClock(),
					timeout: window.setTimeout( ()=>{ this.clock() }, this.state.interval)
				});
			})
		}
	}
	clock() {
		if ( ! this.state.timer ) {
			if ( this.state.timeout ) try { window.clearTimeout( this.state.timeout ) } catch(e){}
			this.setState({ clock: false, timeout: false, timer: false });
			return "";
		}
		this.setState({
			timeout: window.setTimeout( ()=>{ this.clock() }, this.state.interval ),
			clock: this.buildClock()
		})
	}
	doneButton(e,g,c) {
		if ( ! this.state.isGM ) return '';
		const action = c.action[ e?.id ];
		if ( ! action || typeof g.done[ e.id ] !== 'undefined' ) return "";
		const id = 'Button-'+this.uid;
		return (
			<>
				<Button
					className={"eventAction"}
					color={"danger"}
					size={"sm"}
					id={id+'d'}
					onClick={ (e)=>{
						e.preventDefault();
						e.stopPropagation();
						const a = G.clone(action);
						if ( a.desc ) a.desc = a.desc.replace(/\t/g," ");
						const ans = window.prompt( G.label( 'ConfirmMarkStepOver', a ) )
						if (ans) {
							const data = G.clone(action);
							data.failure = ans;
							G.trigger('event:Admin', {command: 'MarkStepDone', data: data});
						}
					}}
				>
					<TextLabel value={"close"} lang={"icon"} />
				</Button>
				<UncontrolledTooltip
					autohide={true}
					placement={"left"}
					target={id+'d'}
				>
					<TextLabel value={"MarkStepOver"} />
				</UncontrolledTooltip>
				<Button
					className={"eventAction"}
					color={"success"}
					size={"sm"}
					id={id}
					onClick={ (e)=>{
						e.preventDefault();
						e.stopPropagation();
						const a = G.clone(action);
						if ( a.desc ) a.desc = a.desc.replace(/\t/g," ");
						if (window.confirm( G.label( 'ConfirmMarkStepDone', a ) ))
							G.trigger( 'event:Admin', { command: 'MarkStepDone', data: action } );
					}}
				>
					<TextLabel value={"ok"} lang={"icon"} />
				</Button>
				<UncontrolledTooltip
					autohide={true}
					placement={"left"}
					target={id}
				>
					<TextLabel value={"MarkStepDone"} />
				</UncontrolledTooltip>
			</>
		);
	}
	additionalClassName() {
		let c = "step startstep";
		if ( this.props.event?.data?.injection ) c += " injection";
		return c;
	}
	description() {
		const e = this.props.event;
		const g = this.props.options.game;
		const c = this.props.options.copione;
		return(<>
			{ this.state.clock ? this.state.clock : '' }
			{ e.data.name ? <b title={e.data.name}>{ e.data.name }</b> : ''}
			{ this.doneButton(e,g,c) }
		</>);
	}
}

export default EventStartStep;